import { FIREBASE_AUTH } from "../Firebase";

class TimeService {
  private timeOffset: number | null = null;
  private loginTimestamp: number = 0;

  /**
   * Gets the current server time based on the calculated offset
   * @param forceRefreshToken Optional parameter to force a token refresh for critical time calculations
   */
  async getServerTime(forceRefreshToken: boolean = false): Promise<Date | null> {
    // If we're forcing a token refresh, reset the time offset
    if (forceRefreshToken) {
        console.log("force refresh token")
      this.timeOffset = null;
      try {
        localStorage.removeItem('timeOffset');
      } catch (error) {
        // Ignore localStorage errors
      }
    }
    
    // Try to load cached offset first
    if (this.timeOffset === null) {
        console.log("time offset is null")
      const cachedOffset = localStorage.getItem('timeOffset');
      if (cachedOffset && !forceRefreshToken) {
        console.log("a")
        this.timeOffset = parseInt(cachedOffset, 10);
      } else {
        console.log("b")
        // Check if we're in a recent login process (within the last 10 seconds)
        const isRecentLogin = Date.now() - this.loginTimestamp < 10000;
        console.log("isRecent : ", isRecentLogin)
        console.log("isForced:", forceRefreshToken)
        if (!isRecentLogin && !forceRefreshToken) {
          // Only log if not during/right after login and not forced refresh
          console.log("TimeService: No time offset found in localStorage, refreshing token");
        }
        
        // Get a new token and recalculate offset
        try {
          const user = FIREBASE_AUTH.currentUser;
          if (user) {
            // Always refresh the token when explicitly requested or when offset is missing
            
            if (!isRecentLogin) {
                const newToken = await user.getIdToken(true);
              console.log("New token:", newToken);
            }
            
            // Get the token result to calculate offset
            const tokenResult = await user.getIdTokenResult();
            
            // Use issuedAtTime for accurate server time
            const serverTime = new Date(tokenResult.issuedAtTime).getTime();
            const clientTime = Date.now();
            this.timeOffset = serverTime - clientTime;
            
            // Cache the offset in localStorage
            localStorage.setItem('timeOffset', this.timeOffset.toString());
          }
        } catch (error) {
          console.error('Error refreshing token or fetching server time:', error);
          return null;
        }
      }
    }

    if (this.timeOffset !== null) {
      // To get current server time, add the offset to the current client time
      const serverTime = new Date(Date.now() + this.timeOffset);
      return serverTime;
    }
    return null;
  }

  /**
   * Resets the time offset - should be called when a user logs in
   * This ensures we recalculate the time offset with fresh auth data
   */
  public resetTimeOffset(): void {
    this.timeOffset = null;
    this.loginTimestamp = Date.now(); // Record when login happened
    
    try {
      localStorage.removeItem('timeOffset');
    } catch (error) {
      console.warn('Failed to clear time offset from localStorage:', error);
    }
  }
}

const timeService = new TimeService();
export default timeService;